import service from "@/api/service";
import { GetResponse } from "@/api/point-rank/response";
import { GetRequest } from "@/api/point-rank/request";

/**
 * ポイントカードランク数設定取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/get-point-rank", getRequest);
  return response.data as GetResponse;
}
